/*
 * picturepops theme entry point
 * Foundation: empty. Later plans (configurator, gallery, etc.) attach modules here.
 */

(function () {
  'use strict';

  const pp = {
    init() {
      document.documentElement.dataset.ppReady = 'true';
    },
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', pp.init);
  } else {
    pp.init();
  }

  // MERGE into the namespace — don't replace. Other scripts (card3d.js,
  // configurator.js) attach onto window.PP and may have loaded BEFORE this
  // file in the configurator layout's defer order. A bare `window.PP = pp`
  // here wipes out their exports and breaks the 3D builder.
  window.PP = window.PP || {};
  window.PP.init = pp.init;
})();
